<template>
  <button type="button" class="btn-close" @click="closeModal"></button>
</template>

<script>
export default {
  emits:['close'],
  mounted() {
    jQuery(document).on('keyup.modal', (e) => {
      if (e.key === 'Escape') {
        // escape key maps to keycode `27`
        this.closeModal()
      }
    })
  },
  beforeMount() {
    jQuery(document).off('keyup.modal')
  },
  methods:{
    closeModal(){
      this.$emit('close');
    }
  }
}
</script>
